// @flow @jsx h

import { bem } from '@nrk/dh-utils'
import { Component, h } from 'preact'

import styles from './index.css'

type Props = {
  municipality: any,
  municipalityName: string,
  fire: any,
  fireName: string
}

function formatAreaDiff (a: number, b: number) {
  return `${(b / a * 100).toFixed().replace('.', ',')} %`
}

function formatFootballFields (num: number) {
  return `${Math.round(num)
    .toLocaleString()
    .replace(',', ' ')
    .replace('.', ' ')}`
}

function formatArea (num: number) {
  return `${num.toFixed(1).replace('.', ',')}`
}

class Info extends Component<Props> {
  render () {
    const { municipality, municipalityName, fire, fireName } = this.props

    return (
      <div class={styles.info}>
        <h3 class={styles.info__title}>
          Arealet av brannen i <strong>{fireName}</strong> tilsvarer
        </h3>
        {municipality.developed && (
          <div class={styles.info__section}>
            <div class={bem(styles.info__icon, 'developed')} />
            <div class={styles.info__text}>
              <div>
                <strong>
                  {formatAreaDiff(
                    municipality.developed.m2,
                    fire.polygon.properties.m2
                  )}
                </strong>{' '}
                av by og tettsted i {municipalityName}
              </div>
            </div>
          </div>
        )}
        {municipality.forest && (
          <div class={styles.info__section}>
            <div class={bem(styles.info__icon, 'forest')} />
            <div class={styles.info__text}>
              <div>
                <strong>
                  {formatAreaDiff(
                    municipality.forest.m2,
                    fire.polygon.properties.m2
                  )}
                </strong>{' '}
                av skogsarealet i {municipalityName}
              </div>
            </div>
          </div>
        )}
        <div class={styles.info__section}>
          <div class={bem(styles.info__icon, 'football')} />
          <div class={styles.info__text}>
            <div>
              <strong>
                {formatFootballFields(fire.polygon.properties.footballFields)}{' '}
              </strong>{' '}
              fotballbaner
            </div>
          </div>
        </div>
        <div class={styles.info__section}>
          <div class={bem(styles.info__icon, 'fire')} />
          <div class={styles.info__text}>
            <div>
              <strong>
                {formatArea(fire.polygon.properties.km2)} km&sup2;{' '}
              </strong>{' '}
              hittil berørt av brannen
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Info



// WEBPACK FOOTER //
// ./src/v1/components/Info/index.js